import { api } from "@/lib/api";
import { isNetworkError, cacheBatch, cachedBatch } from "@/lib/offlineQueue";

const QKEY = "opname_offline_queue";
export { isNetworkError, cacheBatch, cachedBatch };

export const readOpnQueue = () => { try { return JSON.parse(localStorage.getItem(QKEY) || "[]"); } catch { return []; } };
const write = (q) => { localStorage.setItem(QKEY, JSON.stringify(q)); window.dispatchEvent(new Event("opname-queue-change")); };

export const enqueueCount = (session_id, batch, physical_qty) => {
  const entry = { client_id: `opn-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`, session_id, inventory_id: batch.id, batch_code: batch.batch_code,
    species_name: batch.species_name, size: batch.size, unit: batch.unit || "MC", physical_qty, counted_at: new Date().toISOString(), attempts: 0, last_error: "", failed: false };
  write([...readOpnQueue(), entry]);
  return entry;
};
export const removeOpnQueued = (client_id) => write(readOpnQueue().filter((e) => e.client_id !== client_id));

let flushing = false;
export const flushOpnQueue = async () => {
  if (flushing || !navigator.onLine) return { sent: 0 };
  flushing = true;
  let sent = 0;
  try {
    for (const e of readOpnQueue()) {
      if (e.failed) continue;
      try {
        await api.post(`/opname/sessions/${e.session_id}/count`, { inventory_id: e.inventory_id, physical_qty: e.physical_qty, client_id: e.client_id, counted_at: e.counted_at });
        removeOpnQueued(e.client_id); sent++;
      } catch (err) {
        if (isNetworkError(err)) break;
        write(readOpnQueue().map((x) => (x.client_id === e.client_id ? { ...x, failed: true, attempts: (x.attempts || 0) + 1, last_error: err?.response?.data?.detail || "Ditolak server" } : x)));
      }
    }
  } finally { flushing = false; }
  return { sent };
};
